<template>
  <div class="container-fluid estoque-principal">
    <div class="p-3 text-center">
      <img src="@/assets/estoque.svg" alt="Icone de estoque" />
      <h4 class="mb-2 font-1">Estoque</h4>
    </div>
    <b-row class="mt-2">
      <b-col sm="4" md="2">
        <div class="p-2 e text-center margin-estoque">
          <h5>KG</h5>
          <div class="font-estoque">{{ quantities.kg }}</div>
        </div>
      </b-col>
      <b-col sm="4" md="2">
        <div class="p-2 text-center margin-estoque">
          <h5>BDJ</h5>
          <div class="font-estoque">{{ quantities.plate }}</div>
        </div>
      </b-col>
      <b-col sm="4" md="2">
        <div class="p-2 text-center margin-estoque">
          <h5>UN</h5>
          <div class="font-estoque">
            {{ quantities.unity }}
          </div>
        </div>
      </b-col>
      <b-col sm="4" md="2">
        <div class="form-group margin-estoque">
          <h5>Produto</h5>
          <b-form-select
            id="escolhaOpcao"
            v-model="opcaoSelecionada"
            class="form-control select-responsivo"
          >
            <option value="" disabled selected>Selecione um produto</option>
            <option
              v-for="product in products"
              :value="product.id"
              :key="product.id"
            >
              {{ product.type }}
            </option>
          </b-form-select>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { Products } from '../../services/Product';
import showError from '../../utils/showError';

export default {
  data() {
    return {
      opcaoSelecionada: null,
      products: {
        id: '',
        type: '',
        quantity_kg: '',
        quantity_plate: '',
        quantity_unity: '',
      },
      quantities: {
        kg: 0,
        plate: 0,
        unity: 0,
      },
    };
  },

  created() {
    Products()
      .then((response) => {
        this.products = response.data;
      })
      .catch(showError);
  },

  watch: {
    opcaoSelecionada() {
      if (this.opcaoSelecionada) {
        const produto = this.products.find(
          (product) => product.id === this.opcaoSelecionada
        );
        this.quantities.kg = produto.quantity_kg;
        this.quantities.plate = produto.quantity_plate;
        this.quantities.unity = produto.quantity_unity;
      } else {
        this.quantities.kg = 0;
        this.quantities.plate = 0;
        this.quantities.unity = 0;
      }
    },
  },
};
</script>

<style scoped>
.estoque-principal {
  display: flex;
  border-radius: 13px;
  background: rgba(217, 217, 217, 1);
}

.font-estoque {
  color: #000;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.margin-estoque {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-left: 210px;
  width: 100px;
}

.select-responsivo {
  width: 200px;
  border: 1px solid black;
  background-color: transparent;
  outline: none;
  box-shadow: none;
  color: black;
}

.font-1 {
  color: #be8250;
}
</style>
